// extracted by mini-css-extract-plugin
export var hidden = "_vm-0";